var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.towing.externalId)), _c('v-spacer'), _vm.canUpdateReport ? _c('m-icon-button', {
    staticClass: "ma-2",
    on: {
      "click": function click($event) {
        return _vm.$emit('edit', _vm.towing.id);
      }
    }
  }) : _vm._e()], 1), _vm.towing.url ? _c('v-card-subtitle', [_c('v-icon', {
    attrs: {
      "x-small": "",
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _c('a', {
    attrs: {
      "href": _vm.towing.url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.towing.details")) + " ")])], 1) : _vm._e(), _c('v-card-text', [_vm.towing.company ? _c('company-sheet', {
    attrs: {
      "company": _vm.towing.company,
      "color": "white"
    }
  }) : _vm._e(), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.towing.pickupDate'),
      "readonly": "",
      "hide-details": "",
      "type": "datetime-local"
    },
    model: {
      value: _vm.towing.pickupDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.towing, "pickupDateFormable", $$v);
      },
      expression: "towing.pickupDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_vm.towing.cost ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.towing.cost'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.towing.cost,
      callback: function callback($$v) {
        _vm.$set(_vm.towing, "cost", $$v);
      },
      expression: "towing.cost"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.towing.notes ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.towing.notes'),
      "readonly": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.towing.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.towing, "notes", $$v);
      },
      expression: "towing.notes"
    }
  }) : _vm._e()], 1)], 1), _c('v-subheader', {
    staticClass: "pl-0 mb-n3"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.towing.pickup")) + " ")]), _c('v-sheet', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-map-marker-outline")])], 1), _c('v-list-item-content', [_vm.towing.pickupLocation && (_vm.towing.pickupLocation.line2 || _vm.towing.pickupLocation.street || _vm.towing.pickupLocation.zip || _vm.towing.pickupLocation.city) ? _c('v-list-item-title', [_vm.towing.pickupLocation.line2 ? _c('span', [_vm._v(_vm._s(_vm.towing.pickupLocation.line2) + " "), _c('br')]) : _vm._e(), _vm.towing.pickupLocation.street ? _c('span', [_vm._v(_vm._s(_vm.towing.pickupLocation.street) + ", "), _c('br')]) : _vm._e(), _vm.towing.pickupLocation.zip || _vm.towing.pickupLocation.city ? _c('span', [_vm._v(" " + _vm._s(_vm.towing.pickupLocation.zip) + " " + _vm._s(_vm.towing.pickupLocation.city) + " ")]) : _vm._e()]) : _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerAccidentDetailsTimeLineElement.noAddress")) + " ")])], 1)], 1)], 1), _c('v-subheader', {
    staticClass: "pl-0 mb-n3"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.towing.delivery")) + " ")]), _c('v-sheet', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-flag-outline")])], 1), _c('v-list-item-content', [_vm.towing.deliveryDate ? _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("detailedDate")(_vm.towing.deliveryDate)) + " ")]) : _vm._e(), _vm.towing.deliveryLocation && (_vm.towing.deliveryLocation.line2 || _vm.towing.deliveryLocation.street || _vm.towing.deliveryLocation.zip || _vm.towing.deliveryLocation.city) ? _c('v-list-item-title', [_vm.towing.deliveryLocation.line2 ? _c('span', [_vm._v(_vm._s(_vm.towing.deliveryLocation.line2) + " "), _c('br')]) : _vm._e(), _vm.towing.deliveryLocation.street ? _c('span', [_vm._v(_vm._s(_vm.towing.deliveryLocation.street) + ", "), _c('br')]) : _vm._e(), _vm.towing.deliveryLocation.zip || _vm.towing.deliveryLocation.city ? _c('span', [_vm._v(" " + _vm._s(_vm.towing.deliveryLocation.zip) + " " + _vm._s(_vm.towing.deliveryLocation.city) + " ")]) : _vm._e()]) : _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("timeLine.PartnerAccidentDetailsTimeLineElement.noAddress")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }